import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, queue, throwError } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { IPinNumVerification } from 'src/app/models/IPinNumVerification';
import { IResponseResult } from 'src/app/models/IResponseResult';
//import { IPinNumVerification } from 'src/app/models/IPinNumVerification';
import { environment } from 'src/environments/environment';
import { HttphelperService } from '../helpers/httphelper.service';


@Injectable()
export class PatientcodeverificationService {
  constructor(private httpHelper:HttphelperService) {    
  }
  verifyPatCode(code:string):Observable<IResponseResult>
  {
    var url = "api/Account/PatCodeVerification";
    //return this.httpHelper.getRequest(url,false)
    return this.httpHelper.postRequest(url,false,{patientcode:code})
  }
  verifyPin(pin:string,code:string,queueId:string):Observable<IResponseResult>
  {
    var url = "api/Account/PinNumVerification";
    var pinModel : IPinNumVerification = {patientcode:code,pinNum:pin,queueId:queueId};
    return this.httpHelper.postRequest(url ,false,pinModel)
  } 
}

